import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_ADDIN } from '~/contexts/addin/router/routes'

const ADDIN_ROUTE: RouteRecordRaw = {
  name: ROUTE_ADDIN.HOME,
  path: '',
  component: () => import('~/contexts/addin/pages/addin.vue'),
  meta: {
    name: 'addin',
    leftNavigation: false,
  },
}

/** Register all community routes as child of "/community" namespace */
export function getRoutes() {
  return [
    ADDIN_ROUTE,
  ]
}
